var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29424 0.898533C7.81544 -0.299515 6.18458 -0.299507 5.70578 0.898533L4.47816 3.97023L1.29166 4.23609C0.0488399 4.33978 -0.455098 5.95391 0.4918 6.79804L2.91957 8.96229L2.17784 12.1983C1.88855 13.4604 3.2079 14.458 4.27193 13.7816L7.00001 12.0475L9.72813 13.7816C10.7921 14.458 12.1115 13.4604 11.8222 12.1983L11.0805 8.96229L13.5082 6.79804C14.4551 5.95391 13.9512 4.33978 12.7084 4.23609L9.52184 3.97023L8.29424 0.898533Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b45d07ca899cc6df277ff4d76dd246f3.svg";
export { ForwardRef as ReactComponent };